import clsx from 'clsx'

import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip'

export const useStyles = makeStyles(
  (theme) => (
    {
	 chipPink: {
        backgroundColor: '#906e91',
        color: 'white',
      },
      chipBlue: {
        backgroundColor: '#1686c7',
        color: 'white',
      },
      chipGreen: {
        backgroundColor: '#5fb36f',
        color: 'white',
      },
      chipOrange: {
        backgroundColor: '#f76f14',
        color: 'white',
      },
      marginChip: {
        marginRight: '1px',
        marginLeft: '1px',
      },
    }
  )
);

export const AplicarLegenda = ({ params }) => {
  const classes = useStyles();
  return (
    <>
	  <Chip size="small" label={params[0]} className={clsx(classes.chipPink, classes.marginChip)}></Chip>
      { params[1] != null ?<Chip size="small" label={params[1]} className={clsx(classes.chipBlue, classes.marginChip)}></Chip> : null }
      { params[2] != null ? <><Chip size="small" label={params[2]} className={clsx(classes.chipOrange, classes.marginChip)}/></> : null }
      { params[3] != null ? <><Chip size="small" label={params[3]} className={clsx(classes.chipGreen, classes.marginChip)}/></> : null }
    </>
  )
}
